import React from 'react';
import {
  Header, Icon, Segment,
} from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const ValidateDataResultsValid = () => (
  <Segment attached="bottom" placeholder className="aridhia-validate-data-results-valid">
    <Header icon>
      <Icon name="check circle" color="green" />
      <FormattedMessage id="dataset.data.validation.success" />
    </Header>
  </Segment>
);

export default ValidateDataResultsValid;
